@if (blueprintItem.linked_to_blueprint_id; as referencedBlueprintId) {
  @if (getReferencedBlueprint(referencedBlueprintId); as refBlueprint) {
    <!-- This BlueprintItem references another blueprint - show the full blueprint structure -->
    <div class="definition-item border-l-2 border-primary pl-3">
      <div class="flex items-center gap-2 py-1">
        <span class="font-medium text-primary">
          <i class="pi pi-file mr-1"></i>{{ blueprintItem.name }}
        </span>
        <span class="text-xs text-surface-switch-500"
          >(Blueprint: {{ refBlueprint.name }})</span
        >
        @if (tradeStudyToolFeaturesEnabled$ | async) {
          <span class="text-xs text-surface-switch-500">
            CapEx: {{ getCapexLinkedCount(blueprintItem) }} linked
          </span>
        }
        @if (consumablesEnabled$ | async) {
          <span class="text-xs text-surface-switch-500">
            Consumables: {{ getConsumableCount(blueprintItem) }}
          </span>
        }
      </div>
      <!-- Display all root items from the referenced blueprint -->
      <div class="ml-4 mt-2 space-y-2">
        @if (refBlueprint.items && refBlueprint.items.length > 0) {
          @for (refItem of getRootItems(refBlueprint); track refItem.id) {
            <!-- Recursively render each item from the referenced blueprint -->
            <!-- This will show the full tree structure including nested blueprints -->
            <app-blueprint-item-viewer
              [blueprintItem]="refItem"
              [blueprint]="refBlueprint"
              [blueprintMap]="blueprintMap"
            />
          }
        } @else {
          <!-- Empty blueprint -->
          <div class="text-xs text-surface-switch-500 italic">
            (Empty blueprint)
          </div>
        }
      </div>
    </div>
  } @else {
    <!-- Referenced blueprint not found in blueprintMap -->
    <div class="definition-item">
      <div class="flex items-center gap-2 py-1">
        <span class="font-medium text-primary">
          <i class="pi pi-file mr-1"></i>{{ blueprintItem.name }}
        </span>
        <span class="text-xs text-surface-switch-500"
          >(Blueprint ID: {{ referencedBlueprintId }} - not found)</span
        >
      </div>
    </div>
  }
} @else {
  <div class="definition-item">
    <div class="flex items-center gap-2 py-1 flex-wrap">
      <span class="font-medium">{{ blueprintItem.name }}</span>
      @if (blueprintItem.quantity) {
        <span class="text-sm text-surface-switch-500"
          >Qty: {{ blueprintItem.quantity }},</span
        >
      }
      @if (blueprintItem.unit_cost && !blueprintItem.pricing_model_id) {
        <!--        ToDo: Once non-base currency feature has been introduced:
                    1. When viewing in the blueprints settings context: Use the base currency
                    2. When viewing in the quotes context: Convert to the quote currency
                    (?Check this via optional dependency injection of the QuoteService?)
-->
        <span class="text-sm text-surface-switch-500"
          >Cost:
          {{
            blueprintItem.unit_cost
              | currency
                : (settingsService.settings$ | async)
                    ?.organisation_base_currency_code ?? "GBP"
          }},</span
        >
      }
      @if (
        blueprintItem.markup_percentage &&
        !(tradeStudyToolFeaturesEnabled$ | async)
      ) {
        <span class="text-sm text-surface-switch-500 italic"
          >Markup: {{ blueprintItem.markup_percentage }}%,</span
        >
      }

      @if (blueprintItem.pricing_model_name) {
        <span class="text-sm text-surface-switch-500"
          >Pricing Model: {{ blueprintItem.pricing_model_name }},</span
        >
      }

      @if (blueprintItem.material_name) {
        <span class="text-sm text-surface-switch-500"
          >Material: {{ blueprintItem.material_name }}</span
        >
      }

      @if (tradeStudyToolFeaturesEnabled$ | async) {
        <span class="text-sm text-surface-switch-500">
          CapEx: {{ getCapexLinkedCount(blueprintItem) }} linked
        </span>
      }
      @if (consumablesEnabled$ | async) {
        <span class="text-sm text-surface-switch-500">
          Consumables: {{ getConsumableCount(blueprintItem) }}
        </span>
      }
    </div>
    @if (blueprintItem.id && getChildren(blueprintItem.id).length > 0) {
      <div
        class="ml-6 mt-1 space-y-1 border-l-2 border-surface-switch-300 pl-3"
      >
        @for (child of getChildren(blueprintItem.id!); track child.id) {
          <app-blueprint-item-viewer
            [blueprintItem]="child"
            [blueprint]="blueprint"
            [blueprintMap]="blueprintMap"
          />
        }
      </div>
    }
  </div>
}
